/* 🤖 this file was generated by svg-to-ts*/
export const icoEdit: {
  name: 'edit';
  data: string;
} = {
  name: 'edit',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.076 22c.087 0 .175-.01.26-.032l4.305-1.078c.19-.047.363-.145.5-.283L21.37 7.365A2.14 2.14 0 0022 5.842a2.14 2.14 0 00-.63-1.523l-1.707-1.708c-.814-.815-2.23-.815-3.043 0L3.392 15.853a1.081 1.081 0 00-.283.5L2.032 20.66A1.078 1.078 0 003.076 22zM18.141 4.134l1.707 1.708-1.707 1.709-1.706-1.709 1.706-1.708zM5.124 17.164l9.789-9.799 1.707 1.709-9.79 9.799-2.275.569.569-2.277z" fill="#909090"/></svg>`
};
